import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {signupToCourse, signoutToCourse} from '../../actions';
import {toggleDrawer} from '../../../Layout/actions';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import momentDurationFormat from 'moment-duration-format';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DoneIcon from '@material-ui/icons/Done';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CheckCircleOutlineIcon from '../../assets/img/CheckCircleOutline';
import IconInfo from '../../assets/img/InfoIcon';
import IconInfo2 from '@material-ui/icons/Info';
import UndoIcon from '@material-ui/icons/Undo';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepClock from '../../../Layout/assets/img/icon-agep-clock.svg';
import IconAgepOpenBook from '../../../Layout/assets/img/icon-agep-open-book.svg';
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloseIcon from '@material-ui/icons/Close';
import Drawer from "@material-ui/core/Drawer/Drawer";

class CourseDetails extends Component {
    state = {
        currentUserCheckedIn: false,
        dialogCheckinSubscribeOpen: false,
        dialogCheckinUnsubscribeOpen: false,
        dialogCheckinSubscribeConfirmOpen: false,
        dialogCheckinUnsubscribeConfirmOpen: false,
        mobileInfoDrawerOpen: false,
    };

    componentDidMount() {
        const {course} = this.props;
        this.setState({currentUserCheckedIn: course.currentUserCheckedIn});
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupOrOut !== this.props.signupOrOut) {
            if (this.props.signupOrOut) {
                if (this.state.currentUserCheckedIn && this.state.dialogCheckinUnsubscribeOpen) {
                    // The user want to unsubscribe, and has been just unsubscribed (signed out)
                    // Hide the unsubscribe dialog, and show the confirmation dialog.
                    this.setState({
                        currentUserCheckedIn: !this.state.currentUserCheckedIn,
                        dialogCheckinUnsubscribeOpen: false,
                        dialogCheckinUnsubscribeConfirmOpen: true,
                    });
                } else if (!this.state.currentUserCheckedIn && this.state.dialogCheckinSubscribeOpen) {
                    // The user want to subscribe, and has been just subscribed (signed up)
                    // Hide the subscribe dialog, and show the confirmation dialog.
                    this.setState({
                        currentUserCheckedIn: !this.state.currentUserCheckedIn,
                        dialogCheckinSubscribeOpen: false,
                        dialogCheckinSubscribeConfirmOpen: true,
                    });
                }
            }
        }
    }

    handleClickOpenDialog = (name) => () => {
        this.setState({
            ['dialog' + name + 'Open']: true
        });
    };

    handleClickCloseDialog = (name) => () => {
        this.setState({
            ['dialog' + name + 'Open']: false
        });
    };

    handleSignup = (e) => {
        e.preventDefault();
        const {course} = this.props;
        this.props.signupToCourse(course.slug);
    };

    handleSignout = (e) => {
        e.preventDefault();

        const {course} = this.props;

        this.props.signoutToCourse(course.slug);
    };

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    toggleInfoDrawer = (open) => () => {
        this.setState({
            mobileInfoDrawerOpen: open,
        });
    };

    render() {
        const {course, signupOrOutLoading, signupOrOut} = this.props;
        const {isAuthenticated} = this.props.auth;

        momentDurationFormat(moment);
        moment.locale('fr');

        let idArticle = 'course-' + course.id;

        let title = course.title;
        if (course.title_html !== '' && course.title_html !== null) {
            title = ReactHtmlParser(course.title_html);
        }

        let categoryName = '';
        if (Array.isArray(course.categories) && course.categories.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyCategories = course.categories.slice(0);
            let category = copyCategories.shift();
            categoryName = category.name;
        }

        let levels = '';
        if (Array.isArray(course.levels) && course.levels.length > 0) {
            course.levels.forEach((term, index) => {
                levels += term.name + '<br />';
            });
            levels = levels.replace(/^\s*<br\s*\/?>|<br\s*\/?>\s*$/g,'');
        }

        let durationSessions = '';
        let nextSessionDate = '';
        if (Array.isArray(course.sessions) && course.sessions.length > 0) {
            // Sort the sessions by date ASc

            let compare = function(a, b) {
                return a.date > b.date;
            };

            let sessions = course.sessions.sort(compare);

            // Get the total duration of the course

            let durationMinutes = 0;

            sessions.forEach((session, index) => {
                if (session.hour_start !== '' && session.hour_end !== '') {
                    let date1 = moment(session.date + ' ' + session.hour_start, 'YYYY-MM-DD HH:mm:ss');
                    let date2 = moment(session.date + ' ' + session.hour_end, 'YYYY-MM-DD HH:mm:ss');

                    let diff = date2.diff(date1, 'minutes');

                    if (diff > 0) {
                        durationMinutes += diff;
                    }
                }
            });

            if (durationMinutes > 0) {
                let format = (durationMinutes % 60 === 0) ? 'h [heures]' : 'h[h] m[min]';
                durationSessions = moment.duration(durationMinutes, 'minutes').format(format);
            }

            // Get the closest session

            let today = moment().format('YYYY-MM-DD');
            sessions.forEach((session, index) => {
                if (session.date >= today && nextSessionDate === '') {
                    nextSessionDate = session.date;
                }
            });
        }

        let nbSeatsLeft = 0;
        if (course.number_seats > 0 && Array.isArray(course.checkins)) {
            nbSeatsLeft = course.number_seats - course.checkins.length;
        }

        let schoolAddress = course.place.address_line1;
        if (course.place.address_line2 !== '') {
            schoolAddress += '<br />' + course.place.address_line2;
        }
        if (course.place.address_city !== '') {
            schoolAddress += '<br />';
            if (course.place.address_postal_code !== '') {
                schoolAddress += course.place.address_postal_code + ' ';
            }
            schoolAddress += course.place.address_city;
        }

        const checkinDeadlineDate = moment(course.first_session_date, 'YYYY-MM-DD').subtract(course.checkin_deadline, 'days');
        const checkinDeadlineDatetime = checkinDeadlineDate.format('YYYY-MM-DD');
        const nowDatetime = moment().format('YYYY-MM-DD');
        let openCheckin = true;
        if (nowDatetime > checkinDeadlineDatetime) {
            openCheckin = false;
        }

        return (
            <Fragment>
                <article id={idArticle} className="course">
                    <header>
                        <div className="row no-gutters">
                            <div className="col col-left col-md-7 col-sm-12">
                                <Button size="medium" className="btnBack" component={props => <Link to="/formations" {...props}/>}>
                                    <KeyboardBackspaceIcon className="btnIcon" />
                                    Retour
                                </Button>

                                <h1>{title}</h1>

                                <span className="category">{categoryName}</span>

                                <ul className="highlight clearfix">
                                    {(course.number_seats > 0 && nbSeatsLeft >= 0) &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepPeople} alt="Disponibilité" />
                                            </div>
                                            <div className="content">
                                                <span className="title">Disponibilité</span>
                                                <span className="txt">
                                                    {nbSeatsLeft === 0 ? 'Aucune place' : nbSeatsLeft + ' places'}
                                                </span>
                                            </div>
                                        </li>
                                    }
                                    {durationSessions !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepClock} alt="Durée" />
                                            </div>
                                            <div className="content">
                                                <span className="title">Durée</span>
                                                <span className="txt">
                                                    {durationSessions}
                                                </span>
                                            </div>
                                        </li>
                                    }
                                    <li>
                                        <div className="icon">
                                            <img src={IconAgepOpenBook} alt="Nombre de cours" />
                                        </div>
                                        <div className="content">
                                            <span className="title">Nombre de cours</span>
                                            <span className="txt">
                                                {course.sessions.length} {course.sessions.length > 1 ? 'sessions' : 'session'}
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="col col-right col-md-4 d-sm-none d-none d-md-block d-print-flex offset-1">
                                <div id="aside">
                                    <div className="inner">
                                        <div className="content">
                                            <ul className="clearfix">
                                                {nextSessionDate !== '' &&
                                                    <li>
                                                        <span className="title">Prochaine session</span>
                                                        <div className="content text-capitalize">{moment(nextSessionDate, 'YYYY-MM-DD').format('dddd D MMMM YYYY')}</div>
                                                    </li>
                                                }
                                                {(course.price_public !== '' || course.price_partner !== '') &&
                                                    <li>
                                                        <span className="title">Prix public / partenaire</span>
                                                        <div className="content">
                                                            {course.price_public !== '' ? 'CHF ' + course.price_public : 'N/C'} / {course.price_partner !== '' ? 'CHF ' + course.price_partner : 'N/C'}
                                                        </div>
                                                    </li>
                                                }

                                                {course.is_online &&
                                                    <li>
                                                        <span className="title">Lieu de formation</span>
                                                        <div className="content">
                                                            <strong>Formation ou conférence en ligne</strong><br />
                                                            {course.online_training_url != '' &&
                                                            <a target="_blank" href={`${course.online_training_url}`}>{course.online_training_url}</a>
                                                            }
                                                        </div>
                                                    </li>
                                                }

                                                {course.place && course.place.name !== '' && course.is_online === false &&
                                                    <li>
                                                        <span className="title">Lieu de formation</span>
                                                        <div className="content">
                                                            <strong>{course.place.name}</strong><br />
                                                            {course.place.address_city !== '' &&
                                                            <Fragment>
                                                                {ReactHtmlParser(schoolAddress)}
                                                            </Fragment>
                                                            }
                                                            {(course.place.address_latitude !== null && course.place.address_longitude !== null) &&
                                                                <span className="d-print-none">
                                                                <br />
                                                                <a href={'https://maps.google.com/?q=' + course.place.address_latitude + ',' + course.place.address_longitude} id="btn-view-place-map" target="_blank">Voir sur Google Maps</a>
                                                                </span>
                                                            }
                                                        </div>
                                                    </li>
                                                }
                                                <li>
                                                    <span className="title">Langue</span>
                                                    <div className="content">{course.english ? 'Anglais' : 'Français'}</div>
                                                </li>
                                                {levels !== '' &&
                                                    <li>
                                                        <span className="title">Niveau</span>
                                                        <span className="content">{ReactHtmlParser(levels)}</span>
                                                    </li>
                                                }
                                            </ul>
                                            {(course.number_seats > 0 && nbSeatsLeft >= 0 && isAuthenticated) &&
                                                <Fragment>
                                                    {this.state.currentUserCheckedIn ? (
                                                        <Fragment>
                                                            {openCheckin === true ? (
                                                                <Button size="large" className="btn-register" variant="contained" color="primary" onClick={this.handleClickOpenDialog('CheckinUnsubscribe')} disabled={signupOrOutLoading}>
                                                                    <UndoIcon className="btn-icon" />
                                                                    Se désinscrire
                                                                </Button>
                                                            ) : (
                                                                <span className="notice-checkin">Il n'est plus possible de se désinscrire de cette formation.</span>
                                                            )}
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            {openCheckin === true ? (
                                                                <Button size="large" className="btn-register" variant="contained" color="primary" onClick={this.handleClickOpenDialog('CheckinSubscribe')} disabled={signupOrOutLoading}>
                                                                    <CheckCircleOutlineIcon className="btn-icon" />
                                                                    S'inscrire maintenant
                                                                </Button>
                                                            ) : (
                                                                <span className="notice-checkin">Il n'est plus possible de s'inscrire à cette formation.</span>
                                                            )}
                                                        </Fragment>
                                                    )}
                                                </Fragment>
                                            }
                                            {(course.number_seats > 0 && nbSeatsLeft >= 0 && !isAuthenticated) &&
                                                <Fragment>
                                                    {openCheckin === true ? (
                                                        <Button size="large" className="btn-register" variant="contained" color="primary" onClick={this.toggleDrawer('signin', true)}>
                                                            <CheckCircleOutlineIcon className="btn-icon" />
                                                            S'inscrire maintenant
                                                        </Button>
                                                    ) : (
                                                        <span className="notice-checkin">Il n'est plus possible de s'inscrire à cette formation.</span>
                                                    )}
                                                </Fragment>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Drawer id="info-drawer" anchor="right" open={this.state.mobileInfoDrawerOpen} onClose={this.toggleInfoDrawer(false)} className="header-drawer" classes={{
                            paper: 'header-drawer-paper almost-full info-drawer',
                        }}>
                            <div className="wrapper wrapper-top">
                                <div className="inner">
                                    <div className="drawer-title">
                                        <span className="section">Formation</span>
                                        <h2 className="title">Informations</h2>
                                        <Button size="large" className="btn-close-drawer" onClick={this.toggleInfoDrawer(false)}>
                                            <CloseIcon className="m-icon" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="wrapper wrapper-bottom">
                                <div className="inner">
                                    <div className="content">
                                        <ul className="clearfix">
                                            {nextSessionDate !== '' &&
                                            <li>
                                                <span className="title">Prochaine session</span>
                                                <div className="content text-capitalize">{moment(nextSessionDate, 'YYYY-MM-DD').format('dddd D MMMM YYYY')}</div>
                                            </li>
                                            }
                                            {(course.price_public !== '' || course.price_partner !== '') &&
                                            <li>
                                                <span className="title">Prix public / partenaire</span>
                                                <div className="content">
                                                    {course.price_public !== '' ? 'CHF ' + course.price_public : 'N/C'} / {course.price_partner !== '' ? 'CHF ' + course.price_partner : 'N/C'}
                                                </div>
                                            </li>
                                            }
                                            {course.place && course.place.name !== '' &&
                                            <li>
                                                <span className="title">Lieu de formation</span>
                                                <div className="content">
                                                    <strong>{course.place.name}</strong><br />
                                                    {course.place.address_city !== '' &&
                                                    <Fragment>
                                                        {ReactHtmlParser(schoolAddress)}
                                                    </Fragment>
                                                    }
                                                    {(course.place.address_latitude !== null && course.place.address_longitude !== null) &&
                                                    <Fragment>
                                                        <br />
                                                        <a href={'https://maps.google.com/?q=' + course.place.address_latitude + ',' + course.place.address_longitude} id="btn-view-place-map" target="_blank">Voir sur Google Maps</a>
                                                    </Fragment>
                                                    }
                                                </div>
                                            </li>
                                            }
                                            <li>
                                                <span className="title">Langue</span>
                                                <div className="content">{course.english ? 'Anglais' : 'Français'}</div>
                                            </li>
                                            {levels !== '' &&
                                            <li>
                                                <span className="title">Niveau</span>
                                                <span className="content">{ReactHtmlParser(levels)}</span>
                                            </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Drawer>
                    </header>
                    <div className="row row-content">
                        <div className="col col-md-7 col-sm-12">
                            <section id="presentation">
                                <h2>Présentation</h2>
                                <div className="content">
                                    {ReactHtmlParser(course.content)}
                                </div>
                            </section>
                            <section id="course-infos" className="grey">
                                <h2>Caractéristiques</h2>
                                <div className="content">
                                    <ul className="items clearfix">
                                        {course.price_public !== '' &&
                                            <li className="clearfix">
                                                <span className="left">Prix public</span>
                                                <span className="right">CHF {course.price_public}</span>
                                            </li>
                                        }
                                        {course.price_partner !== '' &&
                                            <li className="clearfix">
                                                <span className="left">Prix partenaire</span>
                                                <span className="right">CHF {course.price_partner}</span>
                                            </li>
                                        }
                                        {(course.place && course.place.name !== '') &&
                                            <li className="clearfix">
                                                <span className="left">Lieu</span>
                                                <span className="right">{course.place.name}</span>
                                            </li>
                                        }
                                        {levels !== '' &&
                                            <li className="clearfix">
                                                <span className="left">Niveau</span>
                                                <span className="right">{ReactHtmlParser(levels)}</span>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </section>
                            <section id="course-dates">
                                <h2>Dates</h2>
                                <div className="content">
                                    {(Array.isArray(course.sessions) && course.sessions.length > 0) ? (
                                        <ul className="items clearfix">
                                            {course.sessions.map((session, index) => {
                                                let date = moment(session.date, 'YYYY-MM-DD').format('dddd D MMMM YYYY');
                                                let hour = '';
                                                if (session.hour_start !== '' && session.hour_end !== '') {
                                                    hour = 'De ' + session.hour_start.substring(0, 5) + ' à ' + session.hour_end.substring(0, 5);
                                                } else if (session.hour_start !== '') {
                                                    hour = session.hour_start.substring(0, 5);
                                                }

                                                return (
                                                    <li className="clearfix" key={index}>
                                                        <span className="left text-capitalize">{date}</span>
                                                        <span className="right">{hour}</span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : (
                                        <p>Il n'y a pour l'instant aucune date pour cette formation.</p>
                                    )}
                                </div>
                            </section>
                            <section id="course-speakers" className="grey">
                                <h2>Intervenants</h2>
                                <div className="content">
                                    {(Array.isArray(course.speakers) && course.speakers.length > 0) ? (
                                        <ul className="items clearfix">
                                            {course.speakers.map((speaker, index) => {
                                                let name = '';
                                                if (speaker.first_name !== '' && speaker.last_name !== '') {
                                                    name = speaker.first_name + ' ' + speaker.last_name;
                                                } else {
                                                    name = speaker.full_name;
                                                }

                                                return (
                                                    <ul className="items clearfix" key={index}>
                                                        <li className="clearfix">
                                                            <span className="title">{name}</span>
                                                            {speaker.job !== '' &&
                                                                <span className="subtitle">{speaker.job}</span>
                                                            }
                                                        </li>
                                                        {speaker.description !== '' &&
                                                            <li className="description">
                                                                {speaker.description}
                                                            </li>
                                                        }
                                                    </ul>
                                                )
                                            })}
                                        </ul>
                                    ) : (
                                        <p>Il n'y a pour l'instant aucun intervenant pour cette formation.</p>
                                    )}
                                </div>
                            </section>
                        </div>
                    </div>
                </article>

                <Dialog
                    open={this.state.dialogCheckinSubscribeOpen}
                    onClose={this.handleClickCloseDialog('CheckinSubscribe')}
                    aria-labelledby="dialog-checkin-subscribe-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-subscribe-title">
                            <span className="title">S'inscrire à</span>
                            <span className="subtitle">{title}</span>
                        </div>
                        <div className="buttons">
                            {signupOrOutLoading ? (
                                <LoadingSpinner align="center" />
                            ) : (
                                <Fragment>
                                    <Button onClick={this.handleSignup} className="btn btn-confirm" variant="contained" color="primary" size="large" autoFocus>
                                        <DoneIcon className="icon" />
                                        Confirmer
                                    </Button>
                                    <br />
                                    <Button onClick={this.handleClickCloseDialog('CheckinSubscribe')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                        Annuler
                                    </Button>
                                </Fragment>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.state.dialogCheckinUnsubscribeOpen}
                    onClose={this.handleClickCloseDialog('CheckinUnsubscribe')}
                    aria-labelledby="dialog-checkin-unsubscribe-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-title">
                            <span className="title">Se désinscrire de</span>
                            <span className="subtitle">{title}</span>
                        </div>
                        <div className="buttons">
                            {signupOrOutLoading ? (
                                <LoadingSpinner align="center" />
                            ) : (
                                <Fragment>
                                    <Button onClick={this.handleSignout} className="btn btn-confirm" variant="contained" color="primary" size="large" autoFocus>
                                        <DoneIcon className="icon" />
                                        Confirmer
                                    </Button>
                                    <br />
                                    <Button onClick={this.handleClickCloseDialog('CheckinUnsubscribe')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                        Annuler
                                    </Button>
                                </Fragment>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.state.dialogCheckinSubscribeConfirmOpen}
                    onClose={this.handleClickCloseDialog('CheckinSubscribeConfirm')}
                    aria-labelledby="dialog-checkin-subscribe-confirm-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-subscribe-confirm-title">
                            <span className="title">Merci !</span>
                            <span className="subtitle">Votre inscription<br />est bien confirmée</span>
                        </div>
                        <div className="message">
                            <p>En cas d'empêchement, vous pouvez vous désinscrire dans votre espace personnel jusqu'aux 15 jours précédents la formation</p>
                        </div>
                        <div className="buttons">
                            <Button onClick={this.handleClickCloseDialog('CheckinSubscribeConfirm')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                Fermer
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.state.dialogCheckinUnsubscribeConfirmOpen}
                    onClose={this.handleClickCloseDialog('CheckinUnsubscribeConfirm')}
                    aria-labelledby="dialog-checkin-unsubscribe-confirm-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-confirm-title">
                            <span className="title">Merci !</span>
                            <span className="subtitle">Votre désinscription<br />est bien confirmée</span>
                        </div>
                        <div className="buttons">
                            <Button onClick={this.handleClickCloseDialog('CheckinUnsubscribeConfirm')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                Fermer
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                <AppBar position="fixed" className="bottom-tabs">
                    <Tabs fullWidth>
                        <Tab className="dark" label="Informations" icon={<IconInfo2 className="btn-icon" />} onClick={this.toggleInfoDrawer(true)} />
                        {(course.number_seats > 0 && nbSeatsLeft >= 0 && isAuthenticated) &&
                            <Fragment>
                                {this.state.currentUserCheckedIn ? (
                                    <Fragment>
                                        {openCheckin === true ? (
                                            <Tab onClick={this.handleClickOpenDialog('CheckinUnsubscribe')} label="Se désinscrire"
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>}  disabled={signupOrOutLoading}/>
                                        ) : (
                                            <Tab label="Désinscriptions fermées"
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>}  disabled={true}/>
                                        )}
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {openCheckin === true ? (
                                            <Tab onClick={this.handleClickOpenDialog('CheckinSubscribe')} label="S'inscrire"
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>}  disabled={signupOrOutLoading}/>
                                        ) : (
                                            <Tab label="Inscriptions fermées"
                                                 icon={<CheckCircleOutlineIcon className="btn-icon"/>}  disabled={true}/>
                                        )}
                                    </Fragment>
                                )}
                            </Fragment>
                        }
                        {(course.number_seats > 0 && nbSeatsLeft >= 0 && !isAuthenticated) &&
                            <Fragment>
                                {openCheckin === true ? (
                                    <Tab onClick={this.toggleDrawer('signin', true)} label="S'inscrire" icon={<CheckCircleOutlineIcon className="btn-icon"/>} />
                                ) : (
                                    <Tab label="Inscriptions fermées" icon={<CheckCircleOutlineIcon className="btn-icon"/>} disabled={true} />
                                )}
                            </Fragment>
                        }
                    </Tabs>
                </AppBar>
            </Fragment>
        );
    }
}

CourseDetails.propTypes = {
    auth: PropTypes.object.isRequired,
    course: PropTypes.object.isRequired,
    signupToCourse: PropTypes.func.isRequired,
    signoutToCourse: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    signupOrOut: state.courses.courseSignupOrOut,
    signupOrOutLoading: state.courses.courseSignupOrOutLoading,
    signupOrOutError: state.courses.courseSignupOrOutError,
    layout: state.layout,
});

export default withRouter(connect(mapStateToProps, {signupToCourse, signoutToCourse, toggleDrawer})(CourseDetails));



// WEBPACK FOOTER //
// ./src/features/Courses/components/Details/CourseDetails.js